import Input from 'components/input/Input';
import { fonts, spacing } from 'modules/metrics';
import styled from 'styled-components';

export const InputStyled = styled(Input)`
  max-width: 472px;
  margin-top: ${spacing.md}px;
  font-size: ${fonts.md}px;
  height: 42px;
`;
